import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Calendar, ChevronRight } from "lucide-react";
import { Badge } from "../components/ui/badge";
import { API, BACKEND_URL } from "../config";
import Footer from "./components/Footer";

export default function NewsPage() {
  const [news, setNews] = useState([]);
  useEffect(() => { axios.get(`${API}/news`).then(res => setNews(res.data)).catch(console.error); }, []);

  return (
    <div data-testid="news-page">
      <div className="min-h-screen pt-24 sm:pt-32 pb-32 px-4 sm:px-6 md:px-12 lg:px-24">
        <div className="max-w-4xl mx-auto">
        <div className="mb-8 sm:mb-16 animate-fade-in">
          <p className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-primary mb-2 sm:mb-4">Legfrissebb</p>
          <h1 className="text-3xl sm:text-5xl md:text-7xl font-bold font-['Syne'] tracking-tighter">Hírek</h1>
        </div>
        <div className="space-y-6 sm:space-y-8">
          {news.map((article, index) => (
            <Link key={article.id} to={`/hirek/${article.slug}`} className="block glass rounded-xl overflow-hidden animate-fade-in card-hover group" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-64 md:w-80 shrink-0">
                  <div className="aspect-video sm:aspect-square">
                    <img src={`${BACKEND_URL}/storage/${article.image}`} alt={article.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                </div>
                <div className="flex-1 p-4 sm:p-6 md:p-8">
                  <div className="flex items-center gap-3 mb-2 sm:mb-4">
                    <Badge className="bg-primary/20 text-primary text-[10px] sm:text-xs">{article.category}</Badge>
                    <span className="text-[10px] sm:text-xs text-muted-foreground flex items-center gap-1"><Calendar className="h-3 w-3" />{new Date(article.published_at).toLocaleDateString('hu-HU', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
                  </div>
                  <h2 className="text-lg sm:text-2xl font-bold font-['Syne'] mb-2 group-hover:text-primary transition-colors">{article.title}</h2>
                  <div className="text-muted-foreground text-xs sm:text-base line-clamp-2 sm:line-clamp-3 [&>*]:inline [&>*]:mb-0" dangerouslySetInnerHTML={{ __html: article.excerpt || '' }} />
                  <div className="mt-3 flex items-center text-primary text-xs sm:text-sm font-medium">Tovább olvasom<ChevronRight className="h-4 w-4 ml-1" /></div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
      </div>
      <Footer />
    </div>
  );
}
